import { render, staticRenderFns } from "./ComplieLeftContent.vue?vue&type=template&id=ffae2470"
import script from "./ComplieLeftContent.vue?vue&type=script&lang=js"
export * from "./ComplieLeftContent.vue?vue&type=script&lang=js"
import style0 from "./ComplieLeftContent.vue?vue&type=style&index=0&id=ffae2470&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports